<div class="wrap">
  <div class="header">
    <h1>Customer management</h1>
    <div class="add_client_and_search_bar">
      <div
        class="add_Clients"
        (click)="openDialogAddClients()"
        (mouseleave)="show = false"
      >
        <span></span>
        <div class="fa-icon-container">
          <fa-icon [icon]="faPlus" class="faPlus"></fa-icon>
        </div>
      </div>

      <div class="search_bar">
        <input
          matInput
          (keyup)="applyFilter($event)"
          placeholder="Search a customer"
          #input
        />

        <!-- <fa-icon [icon]=" faTimes" (click)="resetSearch($event)"></fa-icon> -->
      </div>
    </div>
  </div>

  <div class="container">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'">
          Name
        </th>
        <td mat-cell *matCellDef="let element" [style.text-align]="'center'">
          {{ element?.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="applicationList">
        <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'">
          Application
        </th>
        <td mat-cell *matCellDef="let element" [style.text-align]="'center'">
          <mat-cell [style.text-align]="'center'" class="no-line">
            <ul>
              <li *ngFor="let a of element.applicationList">
                {{ a.ApplicationName }}
              </li>
            </ul>
          </mat-cell>
        </td></ng-container
      >

      <ng-container matColumnDef="isActive">
        <th mat-header-cell [style.width.%]="5" *matHeaderCellDef>
          Active/Inactive
        </th>
        <td mat-cell [style.width.%]="5" *matCellDef="let element">
          <!-- <mat-slide-toggle class="example-margin" (click)="openDialogIsActive(element.isActive, element.id)" -->
          <mat-slide-toggle
            class="example-margin"
            [(ngModel)]="element.isActive"
            color="primary"
          >
          </mat-slide-toggle></td
      ></ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator
      [length]="length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      aria-label="Select page"
    >
    </mat-paginator>
  </div>
</div>
